import Vue from 'vue';
import VueRouter from 'vue-router';
import jwtToken from './helpers/jwt-token';

Vue.use(VueRouter);

import store from './store/index';
import routes from './routes';
import {api} from "./config";

const router = new VueRouter({
	mode: 'hash',
	scrollBehavior: () => ({ y: 0 }),
	routes
});

router.beforeEach(async (to, from, next) => {

    //bus.$emit('captureMenu', )
    if(to.name == "login"){
    	if(from.path && (from.path != "/logout")){
    		store.dispatch('setUrl',from.path)
    	}else{
    		store.dispatch('setUrl',"/admin/dashboard")
    	}
    }
	// just logged in: localStorage has token, but state does not have auth user
	/*
	if (jwtToken.getToken() && !store.getters.isLoggedIn) {
		let {data: authUser} = await axios.get(api.currentUser);
		await store.dispatch('setAuthUser', authUser);
	}*/

	if (to.meta.requiresAuth) {
		if (store.getters.isLoggedIn || jwtToken.getToken()){
			return next();
		}else{
    		store.dispatch('setUrl',from.path)
			return next({name: 'login'});
		}
	}

	if (to.meta.requiresAdmin) {
		if (store.getters.isLoggedIn || jwtToken.getToken()){
			if(store.getters.authUser && store.getters.authUser.roles && store.getters.authUser.roles.some(rol => rol.name == 'ROLE_ADMIN')){
				//console.log( "es admin" ,"<--")
				return next();
			}else{
				return next({path: '/admin/dashboard'});
			}
		}else{
    		store.dispatch('setUrl',from.path)
			return next({name: 'login'});
		}
	}
	if (to.meta.requiresGuest) {
		if (store.getters.isLoggedIn || jwtToken.getToken())
			return next({path: '/admin/dashboard'});
		else
			return next();
	}

	// Check if user is blocked
	if (store.getters.isLoggedIn && store.getters.authUser.status === 2) {
		return next({name: 'logout'});
	}

	next();
});

export default router;
